var _path, _rect, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAwv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 180,
    viewBox: "40 10 120 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8235 49C52.7155 49 51 50.7032 51 52.8125V75.3125C51 77.4218 52.7155 79.125 54.8235 79.125H60.4706C62.5786 79.125 64.2941 77.4218 64.2941 75.3125V52.8125C64.2941 50.7032 62.5786 49 60.4706 49H54.8235ZM54.8235 127.75C52.7155 127.75 51 129.453 51 131.562V154.062C51 156.172 52.7155 157.875 54.8235 157.875H60.4706C62.5786 157.875 64.2941 156.172 64.2941 154.062V131.562C64.2941 129.453 62.5786 127.75 60.4706 127.75H54.8235ZM139.529 49C137.421 49 135.706 50.7032 135.706 52.8125V75.3125C135.706 77.4218 137.421 79.125 139.529 79.125H145.176C147.284 79.125 149 77.4218 149 75.3125V52.8125C149 50.7032 147.284 49 145.176 49H139.529ZM139.529 127.75C137.421 127.75 135.706 129.453 135.706 131.562V154.062C135.706 156.172 137.421 157.875 139.529 157.875H145.176C147.284 157.875 149 156.172 149 154.062V131.562C149 129.453 147.284 127.75 145.176 127.75H139.529Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 31.5,
    width: 67,
    height: 15,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41C59.2386 41 57 43.2386 57 46V168C57 169.657 58.3431 171 60 171H140C141.657 171 143 169.657 143 168V46C143 43.2386 140.761 41 138 41H62Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M62 70H138V165C138 165.552 137.552 166 137 166H63C62.4477 166 62 165.552 62 165V70Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwv);
export default __webpack_public_path__ + "static/media/icon_AWV.1c47855bfc48265443d6f137757265a2.svg";
export { ForwardRef as ReactComponent };